import React, { useEffect } from 'react';
import cx from 'classnames';
import './index.scss';

// 只允许从头输入，从尾部删除
const SMSCode = ({ codeLength, submit, smsModalTheme }) => {
  const [value, setValue] = React.useState('');

  useEffect(() => {
    if (value.length === codeLength) {
      submit(value);
    }
  }, [value]);

  // 校验value是否有效，仅仅存在数字才有效
  const isInputValueValid = value => /^\d+$/.test(value);

  const handleChange = (e) => {
    const val = e.target.value || '';
    if (val && !isInputValueValid(val)) return;
    setValue(val);
  };

  const handlePaste = (e) => {
    // 一定要清除默认行为
    e.preventDefault();
    const val = e.clipboardData.getData('text/plain').slice(0, codeLength);
    if (!isInputValueValid(val)) return;
    // 如果之前存在输入，这里直接覆盖，也可以实现不覆盖的，也很简单
    setValue(val);
    // focusInput(index);
  };

  return (
    <div className={cx({
      'captcha-input': true,
      'captcha-input--dark': smsModalTheme === 'dark',
      'captcha-input--light': smsModalTheme === 'light',
      'captcha-input--common': smsModalTheme === 'common',
    })}>
      <div className={cx({
        'captcha-input__list': true,
        'captcha-input__list--len4': codeLength === 4,
      })}>
        <input
          className='captcha-input__list--item'
          maxLength={codeLength}
          type="text"
          inputMode='numeric'
          pattern="\d*"
          autoComplete="one-time-code"
          value={value}
          onChange={handleChange}
          onPaste={handlePaste}
        />
      </div>
    </div>
  );
};

export default SMSCode;
